import React from "react";
import { css } from "@emotion/react";

import Image from "core/Components/Image";
import LinkTo from "core/Components/LinkTo";
import { useAppState } from "core/contexts/AppContext";

type Props = {
    to: string,
    url: string,
};

const CartItemImage: React.FC<Props> = ({ to, url }) => {
    const [, setAppState] = useAppState();

    const closeCartPopup = () => {
        setAppState({
            isOpenCartPopup: false
        });
    };

    const style = css`
        width: 67px;
        height: 67px;
        border-radius: 4px;
        cursor: pointer;
    `;

    return (
        <LinkTo css={style} to={to} onClick={closeCartPopup}>
            <Image image={url} useFocusPoint />
        </LinkTo>
    );
};

export default CartItemImage;